import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation deleteDemoDataMutation($input: DeleteDemoDataInput!) {
		deleteDemoData(input: $input) {
			company {
				id
				hasDemoData
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Demo Data Deleted');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), id: input.companyId}},
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
